import "./Header.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Header({
  activePage,
  setActivePage,
  setOpenLogin,
  openBurger,
  setOpenBurger,
  user,
  cart,
}) {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const deviceType = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? "mobile"
    : "desktop";

  const [search, setSearch] = useState("");

  const changeLanguage = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && search.length > 0) {
      navigate(`/search?search=${search}`);
      setOpenBurger(false);
    }
  };

  return (
    <header className="header">
      <div className="logo">
        <a href="/" onClick={() => setActivePage("home")}>
          <img
            src="https://alexfish-static.s3.eu-north-1.amazonaws.com/alex_fish_logo.svg"
            alt="Logo"
          />
        </a>
      </div>
      <div className="search-bar">
        <div className="input">
          <input
            type="text"
            placeholder="Търси..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>
      <div className="menu">
        {(deviceType === "desktop" ||
          (deviceType === "mobile" && openBurger)) && (
          <ul>
            <li
              onClick={() => setActivePage("home")}
              className={
                activePage === "home" && deviceType === "desktop"
                  ? "active"
                  : ""
              }
            >
              <a href="/">{t("home")}</a>
            </li>
            <li
              onClick={() => setActivePage("menu")}
              className={
                activePage === "menu" && deviceType === "desktop"
                  ? "active"
                  : ""
              }
            >
              <a href="/menu/category/10">{t("menu")}</a>
            </li>
            <li
              onClick={() => setActivePage("promo")}
              className={
                activePage === "promo" && deviceType === "desktop"
                  ? "active"
                  : ""
              }
            >
              <a href="/promotions">{t("promotions")}</a>
            </li>
            {/* <li>
              <select
                onChange={changeLanguage}
                value={i18n.language}
                className="language"
              >
                <option value="en">EN</option>
                <option value="bg">BG</option>
              </select>
            </li> */}
          </ul>
        )}
        <div className="cart-user">
          <div
            className="cart"
            onClick={() => {
              navigate("/cart");
              setActivePage("cart");
            }}
          >
            <img
              src="https://alexfish-static.s3.eu-north-1.amazonaws.com/cart.svg"
              alt="Cart"
            />
            <p className="products-in-cart">{cart?.length}</p>
          </div>
          <div className="user">
            <button
              onClick={() => {
                if (user === null || user?.isGuest) {
                  setOpenLogin(true);
                } else {
                  navigate("/profile");
                  setActivePage("profile");
                }
              }}
            ></button>
          </div>
          {deviceType === "mobile" && (
            <div
              id="burger-menu"
              className={openBurger && "open"}
              onClick={() => setOpenBurger(!openBurger)}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
